import React from 'react';
import PricingIndex from '../_components/Pricing/Index';

const Pricing = () => {
  return <PricingIndex />;
};

export default Pricing;
